// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      equipmentTypeOptions: [
        "EC1",
        "EC2",
        "EC3",
        "EC4",
        "EC5",
        "EC6"
      ],
      equipmentSiteRequirements: [
        "Power",
        "Water",
        "IA",
        "N2",
        "Oil",
        "Diesel",
        "Gas",
        "Comms"
      ],
      equipmentMaintRTFConsequence: [
        "Alarm",
        "Trip",
        "LoF",
        "LoC",
        "Fire",
        "Explosion"
      ],
      // eslint-disable-next-line
      equipmentFailureModes: [
        "UV",
        "Wear",
        "Heat",
        "Cycle"
      ],
      // eslint-disable-next-line
      equipmentMaintMinRequirement: [
        "RTF",
        "Compliance",
        "Vendor"
      ],
      // eslint-disable-next-line
      equipmentOperatingType: [
        "Indpenendent",
        "Package",
        "Component",
        "System"
      ],

    };
  }
};
